<template>
  <b-modal
    ref="modal"
    :title="this.$t('choose-visualization')"
    @ok="okClicked"
    :ok-disabled="!Boolean(value)"
  >
    <b-form-select
      v-if="getSpaceplans"
      v-model="value"
      :options="getSpaceplans"
      value-field="id"
      text-field="name"
      required
    >
      <template v-slot:first>
        <option :value="null">{{ $t('choose') }}</option>
      </template>
    </b-form-select>
    <span v-else>{{ $t("there-is-no-visualizations") }}</span>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ToasterMixin from '@/mixins/Toaster';

export default {
  name: 'SetDefaultVisualizationModalForm',
  mixins: [
    ToasterMixin,
  ],
  data() {
    return {
      value: null,
    };
  },
  computed: {
    ...mapGetters([
      'getSpaceplans',
      'getDefaultSpacePlan',
    ]),
  },
  methods: {
    ...mapActions([
      'loadSpaceplans',
      'updateSpaceplan',
    ]),
    okClicked() {
      this.$refs.modal.hide();
      const spaceplan = this.getSpaceplans.filter(s => s.id === this.value)[0];
      const data = { ...spaceplan };
      delete data.image;
      data.default = true;
      this.updateSpaceplan({ spaceplan, data }).then(
        (resolve) => {
          this.showToast(
            `${this.$t('update-visualization')} ${spaceplan.name}`,
            this.$t('set-as-default'),
            'success',
          );
        },
        (reject) => {
          this.showToast(this.$t('update-visualization'), this.$t('error'), 'danger');
        },
      );
    },
    show() {
      this.$refs.modal.show();
    },
  },
  mounted() {
    this.loadSpaceplans();
    this.value = this.getDefaultSpacePlan ? this.getDefaultSpacePlan : null;
  },
};
</script>

<style scoped>

</style>
